import { fromJS, Iterable, OrderedMap, List, Set } from 'immutable';


export function sum (list, param = null) {
    return list.reduce((result, item) => {
        if (param) {
            return result + (item.get(param, 0) || 0);
        }
        return result + item;
    }, 0);
}

export function compact (list) {
    return list.filter((item) => !!item);
}

export function unique (list, mapper) {
    // OrderedMap keeps first-encounter order; a plain Map iterates in hash order above 8 entries
    const map = list.reduce((reduction, value) => {
        return reduction.set(mapper(value), value);
    }, new OrderedMap());
    return map.toList();
}

export function without (list, item, prop = null) {
    return list.filter((x) => {
        if (prop) {
            return x.get(prop) !== item.get(prop);
        } else {
            return x !== item;
        }
    });
}

export function union (...items) {
  let output = new List();

  do {
    const item = items.shift();
    const prev = new Set(output);

    output = item.reduce(
      (acc, val) => prev.has(val) ? acc : acc.push(val),
      output);
  }
  while (items.length);

  return output;
}

export function isImmutable (arg) {
    return Iterable.isIterable(arg);
}

export function toJS (arg) {
    return isImmutable(arg) ? arg.toJS() : arg;
}

export function toImmutable (arg) {
    return isImmutable(arg) ? arg : fromJS(arg);
}

// Plain object or Immutable Map / Record.
export function getProp (obj, key) {
    if (obj === undefined || obj === null) {
        return undefined;
    }
    return isImmutable(obj) ? obj.get(key) : obj[key];
}

